import { TextInput } from '@components/ui/TextInput';
import { useChangeUsernameMutation } from '@http';
import { useTranslation } from 'react-i18next';
import { Button } from '@components/ui/Button';
import { Modal } from '@components/ui/Modal';
import { useForm } from '@mantine/form';
import { useAppStore } from '@stores';

export function UsernamePopup() {
  const { t } = useTranslation(undefined, { keyPrefix: 'UsernamePopup' });
  const { mutateAsync, isPending } = useChangeUsernameMutation();
  const { userData, tab, refetch } = useAppStore();

  const form = useForm({
    validate: {
      username: (value) => {
        if (!value) {
          return t('Validations.username');
        }
        if (value.length < 3 || value.length > 20) {
          return t('Validations.usernameLength');
        }
        if (!/^[a-zA-Z0-9_]*$/.test(value) || value.startsWith('Player-')) {
          return t('Validations.usernamePattern');
        }
        return null;
      },
    },
    initialValues: {
      username: '',
    },
  });

  const submitUsername = async (values: typeof form.values) => {
    if (isPending) return;
    await mutateAsync({ username: values.username }, {
      onSuccess: () => {
        refetch();
      },
      onError: () => {
        form.setFieldError('username', t('Validations.usernameTaken'));
      },
    });
  };

  const showModal = tab === 'hub'
    && userData.username.startsWith('Player-')
    && userData.tutorials.includes('Inv');

  return (
    <Modal onRequestClose={() => {}} isOpen={showModal} title={t('title')}>
      <div className="p-2">
        <p className="text-shield mb-2 text-sm">
          {t('description')}
        </p>

        <form onSubmit={form.onSubmit((values) => submitUsername(values))}>
          <TextInput label={t('username')} {...form.getInputProps('username')} />
          <Button isLoading={isPending} className="mt-4" type="submit" glitch>
            {t('submit')}
          </Button>
        </form>
      </div>
    </Modal>
  );
}